import { ButtonLink, Header, Stack, StackItem } from '@asgard/ui-library';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { Hero } from './TalentHero.styled';

export const TalentHero: React.FC = () => {
  const { t } = useI18n('talent-new');
  const { locale } = useRouter();

  return (
    <Hero.Root>
      <PageContentContainer containerSize="xlMax">
        <Hero.Wrapper>
          <Hero.Content>
            <Stack direction="column">
              <StackItem>
                <Header editorial as="h1" size="5xl">
                  {t('talent-new.hero.title')}
                </Header>
                <HtmlTrans
                  ns="talent-new"
                  i18nKey={'talent-new.hero.subtitle'}
                />
              </StackItem>

              <Hero.CTAs>
                <ButtonLink
                  href={getAppUrl(APP_URLS.join, locale)}
                  schema="brand1"
                  variant="hard"
                  label={t('talent-new.hero.cta1')}
                  endIcon={faArrowRight}
                />
              </Hero.CTAs>
            </Stack>

            <StackItem>
              <img
                src={getPublicPath(
                  '/images/talent-new/talent-new-hero-image.webp'
                )}
                alt="Talent"
                width="570"
                height="500"
              />
            </StackItem>
          </Hero.Content>
        </Hero.Wrapper>
      </PageContentContainer>
    </Hero.Root>
  );
};
